<template>
  <div class="card-form">
      <EditForm
        class="mb-2"
        ref="editForm"
        :disabled="disabled || displayVehicle"
        :hxShipmentJdCode="hxShipmentJdCode"
        :hxShipmentJdStatus.sync="hxShipmentJdStatus"
      />

      <OrderFiles
        class="mb-2"
        ref="orderFiles"
        :disabled="disabled || displayVehicle"
        :hxShipmentJdCode="hxShipmentJdCode"
      />

      <SkuTable
        class="mb-2"
        ref="skuTable"
        :disabled="disabled || displayVehicle"
        :hxShipmentJdCode="hxShipmentJdCode"
      />

      <Vehicle
        v-if="displayVehicle"
        ref="vehicle"
        :disabled="disabled"
        :hxShipmentJdCode="hxShipmentJdCode"
      />
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import OrderFiles from '../components/order-files'
import Vehicle from '../components/vehicle'
import SkuTable from '../components/sku-table'
export default {
  name: 'ecom-hxBiz-jdShipment-detail',
  components: { EditForm, OrderFiles, Vehicle, SkuTable },
  data() {
    return { hxShipmentJdStatus: '' }
  },
  computed: {
    params() {
      return this.$route.params
    },
    hxShipmentJdCode() {
      return this.params.hxShipmentJdCode
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
    displayVehicle() {
      if (!this.hxShipmentJdStatus) return false
      return this.hxShipmentJdStatus != 'N'
    },
  },
}
</script>
